module.exports = __webpack_public_path__ + "static/media/1209unit1b11b.c957cd74.png";